class EmailAddress {
    id: number;
    address: string;
    primary: boolean;
    unsubscribed: boolean;

    valid?: string;

    constructor(data?: Partial<EmailAddress>) {
        Object.assign(this, data);
    }
}

export default EmailAddress;